<template>
    <v-form>
      <v-row dense>
        <v-col cols="8">
          <v-text-field
            autocomplete="off"
            type="text"
            outlined
            dense
            label="Row Text"
            v-model="record.rowText"
          ></v-text-field>
        </v-col>

        <v-col cols="4">
          <v-autocomplete
          autocomplete="off"
          outlined
          dense
          v-model="record.rowLocation"
          :items="itemTypes"
          item-text="name"
          item-value="value"
          label="Item Type"
        ></v-autocomplete>
        </v-col>
  
        <v-col cols="12">
           <v-btn v-if="docCreate == true" color="accent" @click="sendData" :loading="$store.state.btnLoader">
            <v-icon left>mdi-content-save</v-icon>Save
          </v-btn>
  
          <v-btn v-else color="accent" @click="sendData" :loading="$store.state.btnLoader">
            <v-icon left>mdi-content-save</v-icon>Update
          </v-btn>
        </v-col>
      </v-row>

      <snackbar ref="snackbar"></snackbar>
    </v-form>
  </template>
  
  
  <script>
  export default {
    props: {
      initial: {
        type: Object,
        required: true,
      },
      docCreate: {
        type: Boolean
      },
      location: {
        type: String, 
        default: ''
      }
    },
    computed: {
      storeId() {
        return localStorage.getItem('store_id');
      }
    },
    data: () => ({
      record: {},
      loader: false,
      categories: [],
      date: new Date().toISOString().substr(0, 10),
      itemTypes: [
      { name: "Header", value: "H" },
      { name: "Footer", value: "F" }
    ]
    }),
    watch: {
      initial: {
        handler: "init",
        immediate: true,
      },
      location: {
        handler: "setLocation",
        immediate: false,
      },
    },
    methods: {
      init(val) {
        this.record = { ...val };
      },
      sendData() {
        if(this.record.rowText == undefined || this.record.rowLocation == undefined) {
          this.$refs.snackbar.show('Please fill all the fields', 'red');
        }

        this.record.store_id = parseInt(this.storeId);

        console.log(this.record);
        this.$store.commit("btnLoader", true);
        this.$emit("data", this.record);
      }
    },
    created() {
      
    },
  };
  </script>